/**
 * Application version constant
 * This placeholder is replaced during build with actual version (YYYYMMDD.buildnumber)
 */
export const BUILD_VERSION = '20260216.2310';
